import { motion } from "framer-motion";

interface TeamCardProps {
  role: string;
  name: string;
  image: string;
  description: string;
}

const TeamCard = ({ role, name, image, description }: TeamCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      whileHover="hover"
      className="relative rounded-xl overflow-hidden"
    >
      <img
        src={image}
        alt={name}
        className="w-full h-80 object-cover rounded-xl"
      />

      <div className="absolute bottom-0 left-0 right-0 p-4 bg-black/30 backdrop-blur-sm text-center">
        <h3 className="font-semibold text-lg">{role}</h3>
        <p className="text-sm text-[#C0C0C0]">{name}</p>
      </div>

      <motion.div
        variants={{ hover: { opacity: 1 } }}
        initial={{ opacity: 0 }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
        className="absolute inset-0 flex items-center p-4 bg-[rgba(0,0,0,0.4)] backdrop-blur-md text-left opacity-0"
      >
        <p className="text-neutral-200 text-sm">{description}</p>
      </motion.div>
    </motion.div>
  );
};

export default TeamCard;
